import { action, observable, runInAction } from 'mobx';

import { invoiceDocumentController } from './documentController';
import {
  CreateOrderInvoiceDocumentsRequest,
  EditOrderInvoiceDocumentsRequest,
} from '../../api/documentApi';

export interface InvoiceDocument {
  comment?: string,
  createdDate: string,
  deletedDate: string,
  documentTypeRefValueId: number,
  documentTypeRefValueName: string,
  externalUrl: string,
  fileUrl: string,
  id: string,
  name: string,
  orderInvoiceId: string,
  previewUrl: string,
  sourceRefValueId: number,
  sourceRefValueName: string
}

export interface InvoiceDocumentsStore {
  invoiceDocuments: InvoiceDocument[],
  orderInvoiceId: string,
  error: any,
  currentOrderInvoiceDocument: InvoiceDocument,
}

export interface GetOrderInvoiceDocumentsAction {
  orderInvoiceId: string,
  showDeleted: boolean
}

export const invoiceDocumentsStore: InvoiceDocumentsStore = observable({
  invoiceDocuments: [],
  orderInvoiceId: undefined, // orderInvoiceId - по данному счёту в invoiceDocuments находятся документы
  error: null,
  currentOrderInvoiceDocument: null,
} as InvoiceDocumentsStore);

export const invoiceDocumentsActions = {
  getInvoiceDocuments: async (request: GetOrderInvoiceDocumentsAction): Promise<void> => {
    invoiceDocumentsStore.orderInvoiceId = request.orderInvoiceId;
    const response = await invoiceDocumentController.getOrderInvoiceDocuments(request);
    invoiceDocumentsActions.handleError(response);
    runInAction(() => {
      invoiceDocumentsStore.invoiceDocuments = response.data;
    });
  },

  getInvoiceFromList: async (id: string): Promise<void> => {
    const response = invoiceDocumentsStore.invoiceDocuments.find((v) => v.id === id);
    // invoiceDocumentsActions.handleError(response);
    invoiceDocumentsActions.setCurrentInvoiceDocument(response || null);
  },

  createInvoiceDocument: async (request: CreateOrderInvoiceDocumentsRequest): Promise<void> => {
    const response = await invoiceDocumentController.createOrderInvoiceDocuments(request);
    invoiceDocumentsActions.handleError(response);
  },

  editInvoiceDocument: async (id: string, request: EditOrderInvoiceDocumentsRequest): Promise<void> => {
    const response = await invoiceDocumentController.editOrderInvoiceDocuments(id, request);
    invoiceDocumentsActions.handleError(response);
    invoiceDocumentsActions.setCurrentInvoiceDocument(response.data);
  },

  deleteInvoiceDocument: async (id: string): Promise<void> => {
    const response = await invoiceDocumentController.deleteOrderInvoiceDocuments(id);
    invoiceDocumentsActions.handleError(response);
  },

  clearInvoiceDocuments: action(() => {
    invoiceDocumentsStore.invoiceDocuments = [];
    invoiceDocumentsStore.orderInvoiceId = null;
  }),

  clearCurrentInvoiceDocument: action(() => {
    invoiceDocumentsStore.currentOrderInvoiceDocument = null;
  }),

  clearError: action(() => {
    invoiceDocumentsStore.error = null;
  }),

  handleError: action((response) => {
    if (response.errorData) {
      const { errorData } = response;
      invoiceDocumentsStore.error = errorData;
      throw errorData;
    }
  }),

  setCurrentInvoiceDocument: action((invoice: InvoiceDocument) => {
     
    invoiceDocumentsStore.currentOrderInvoiceDocument = invoice;
  }),
};
